import React from "react";

const LandingItem = ({ element, imageId }) => (
  <div className="landing-item-wrapper large-text-center" id={imageId}>
    <element.component {...element.props} />
  </div>
);

export default LandingItem;
